import { Notify } from "quasar";

export default {
  showToast: (message, color) => {
    Notify.create({
      message,
      color,
      timeout: 2000,
      type:color,
      position: 'top'
    });
  },
};
